
import axios from 'axios';
import React, { useState, useEffect,useRef, useMemo} from 'react';
import {getCookie,getCsrfToken} from './get_csrfToken'

const custom_api_func = axios.create({
    baseURL: 'https://api.successguardian.in/',
    withCredentials: true
});


custom_api_func.interceptors.response.use(
    response => response,
    async error => {
        const originalRequest = error.config;

        if (error.response && error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                await custom_api_func.post('api/access-token-refresh/');
                return custom_api_func(originalRequest); // retry the original request
            } catch (refreshError) {
                console.log('Refresh token failed', refreshError);
                logout()
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);

function logout() {
    localStorage.clear()
    window.location.href = '/';
}

export default custom_api_func;